<section class="simulation grid-container login-page--lg">
    <div>
        <div class="page-header">
            <p class="simulation__panelTitle page-title text-light text-blue">
                {{ 'accountactivation.title' | i18n }}
            </p>
        </div>
        <div class="login-page__content">
            <form id="accountActivationForm" name="accountActivationForm" [formGroup]="accountActivationForm" (ngSubmit)="submitActivation()" class="grid-10 grid-mobile-4">
                <div class="grid-12 login-page__input">
                    <label class="grid-6 grid-mobile-4 ucfirst text-light text-blue" for="otp"> {{ 'accountactivation.form.otp.label' | i18n }}</label>
                    <input class="grid-6 grid-mobile-4 textfield bg-white" id="otp" name="otp" maxlength="20" required="" formControlName="otp" (change)="trimValueOtp()" />
                </div>
                <div class="text-light">
                    <div class="flex-end text-light" (click)="demandeActivation(true)">
                        <span class="login-page__inputdesc login-box__link links">
                            {{ 'accountactivation.form.sendsms.text' | i18n | lowercase }}&nbsp;
                        </span>
                        <span id="re-send-sms-button" data-tag-commander="" [appTagCommander]="'tagCo.accountactivation.sms.button'"
                              class="login-box__link links">
                            {{ 'accountactivation.form.sendsms.clickme' | i18n }}
                        </span>
                    </div>
                    <span class="form-message--success flex-end" *ngIf="sendSMSSucces">
                        {{ 'accountactivation.form.sendsms.success' | i18n }}
                    </span>
                </div>

                <app-password-creation [form]="accountActivationForm" [label]="'accountactivation.form.password.label' | i18n" [labelRepeat]="'accountactivation.form.repeatPassword.label' | i18n"> </app-password-creation>

                <div class="grid-12 login-page__input simulation__group login-page__button">
                    <button
                        id="activation-submit"
                        type="submit"
                        class="grid-6 push-6 grid-mobile-4 push-mobile-0 button button-interaction mb-35"
                        data-tag-commander=""
                        [appTagCommander]="'tagCo.accountactivation.validate.boutton'"
                        data-api-call-button=""
                        [disabled]="!accountActivationForm.valid || newPassword.value != repeatPassword.value"
                        [ngClass]="{ 'icon--loading': submitLoading }"
                    >
                        {{ 'login.form.button.connexion' | i18n}}
                    </button>
                </div>
            </form>
        </div>
    </div>
</section>
